import { motion } from "framer-motion";
import { FileText } from "lucide-react";

function ImpressumPage() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 pb-24 bg-gray-50 dark:bg-gray-900">
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="w-full max-w-md bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-6 mt-8"
      >
        <h2 className="text-xl font-bold mb-4 text-gray-800 dark:text-white flex items-center">
          <FileText className="mr-2 text-green-600" size={20} />
          Impressum
        </h2>
        
        <div className="space-y-4 text-gray-600 dark:text-gray-300">
          <div>
            <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">Angaben gemäß § 5 TMG</h3>
            <p>Max Mustermann</p>
            <p>THC Rechner App</p>
            <p>Musterstraße 123</p>
            <p>12345 Musterstadt</p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">Kontakt</h3>
            <p>Telefon: +49 123 4567890</p>
            <p>E-Mail: info@thc-rechner-app.de</p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold text-gray-800 dark:text-white mb-2">Haftungshinweis</h3>
            <p className="text-sm">
              Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte 
              externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber 
              verantwortlich.
            </p>
          </div>
          
          <div className="pt-2">
            <p className="text-sm italic text-gray-500 dark:text-gray-400">
              Diese Angaben dienen als Beispiel. Bitte ersetzen Sie diese durch Ihre 
              tatsächlichen Daten für eine rechtskonforme Verwendung.
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  );
}

export default ImpressumPage;